export const parseError = (message = null) => {


    if(Array.isArray(message)) {
        if(message.length === 0) return null;
        return message.join(', ');
    } else if(typeof message === 'object') {
        return JSON.stringify(message, null, '\t');
    }

    return message;
}

export const parseExtrinsicError = (event) => {
    if (!event || event.method !== 'ExtrinsicFailed') return null;

    try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (data && data.dispatchError) {
            if (data.dispatchError.Token) {
                return data.dispatchError.Token;
            } else if (data.dispatchError.Module) {
                return `${data.dispatchError.Module.index}:${data.dispatchError.Module.error}`;
            } else {
                return JSON.stringify(data.dispatchError);
            }
        }
    } catch (e) {
        return event.data || 'Unknown error';
    }

    return null;
}

export const parseAddress = (section = 'multisig', data = {}) => {
    return data && section === 'multisig' ? data[1][0] : Array.isArray(data[0]) ? data[0][0] : data[0].to_address.Id ? data[0].to_address.Id : data[0]?.to_address || data[0]
}